blue.ready('sideAlert', '.alert', alrt => {
	const close = alrt.querySelector('.alert-close');

	if (close) {
		close.addEventListener('click', function () {
      let cookieName = close.dataset.dismissCookie;
      let cookieExpirationDays = close.dataset.dismissCookieExpirationDays ?? 30;
      let alertHash = close.dataset.alertHash;

      blue.meth.cookie.set(cookieName, alertHash, "/", cookieExpirationDays);

			alrt.animate(
				[
					{
						height: `${alrt.offsetHeight}px`
					},
					{
						height: 0
					}
				],
				{
					duration: 200,
					easing: 'ease'
				}
			)
			alrt.classList.remove('is-active')
		})
	}
})